export default "__VITE_ASSET__BS4KE89Z__"